import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'bridal_shortlist';

function useShortlist() {
  const [shortlist, setShortlist] = useState([]);

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setShortlist(JSON.parse(stored));
      }
    } catch (err) {
      console.error('Failed to load shortlist:', err);
    }
  }, []);

  // Save to localStorage whenever shortlist changes
  const save = useCallback((items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    setShortlist(items);
    // Dispatch event so other components can react
    window.dispatchEvent(new Event('shortlist-updated'));
  }, []);

  const toggle = useCallback((providerId) => {
    setShortlist(prev => {
      const exists = prev.includes(providerId);
      const updated = exists
        ? prev.filter(id => id !== providerId)
        : [...prev, providerId];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      window.dispatchEvent(new Event('shortlist-updated'));
      return updated;
    });
  }, []);

  const remove = useCallback((providerId) => {
    setShortlist(prev => {
      const updated = prev.filter(id => id !== providerId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      window.dispatchEvent(new Event('shortlist-updated'));
      return updated;
    });
  }, []);

  const clear = useCallback(() => {
    save([]);
  }, [save]);

  const isShortlisted = useCallback((providerId) => {
    return shortlist.includes(providerId);
  }, [shortlist]);

  // Listen for changes from other components
  useEffect(() => {
    const handleUpdate = () => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          setShortlist(JSON.parse(stored));
        }
      } catch (err) {
        // ignore
      }
    };
    window.addEventListener('shortlist-updated', handleUpdate);
    return () => window.removeEventListener('shortlist-updated', handleUpdate);
  }, []);

  return { shortlist, toggle, remove, clear, isShortlisted, count: shortlist.length };
}

export default useShortlist;
